import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BRAND } from './config';
/**
 * One-stop head manager. React 19 auto-hoists <title>, <meta>, <link> and
 * <script type="application/ld+json"> to <head>, so this component works
 * identically in client-side rendering and prerendered SSR.
 */
export function SEO({ title, description, path, image, keywords, type = 'website', schemas = [], breadcrumbs }) {
    const url = BRAND.url + path;
    const img = image ?? `${BRAND.url}/landing/og-default.jpg`;
    const allSchemas = [...schemas];
    if (breadcrumbs?.length) {
        allSchemas.push({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbs.map((b, i) => ({
                '@type': 'ListItem',
                position: i + 1,
                name: b.name,
                item: BRAND.url + b.path,
            })),
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("title", { children: title }), _jsx("meta", { name: "description", content: description }), keywords?.length ? _jsx("meta", { name: "keywords", content: keywords.join(', ') }) : null, _jsx("meta", { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1" }), _jsx("link", { rel: "canonical", href: url }), _jsx("meta", { property: "og:type", content: type }), _jsx("meta", { property: "og:title", content: title }), _jsx("meta", { property: "og:description", content: description }), _jsx("meta", { property: "og:url", content: url }), _jsx("meta", { property: "og:site_name", content: BRAND.name }), _jsx("meta", { property: "og:locale", content: "fa_IR" }), _jsx("meta", { property: "og:image", content: img }), _jsx("meta", { name: "twitter:card", content: "summary_large_image" }), _jsx("meta", { name: "twitter:title", content: title }), _jsx("meta", { name: "twitter:description", content: description }), _jsx("meta", { name: "twitter:image", content: img }), allSchemas.map((s, i) => (_jsx("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: JSON.stringify(s) } }, i)))] }));
}
